<script setup lang="ts">
  interface Emits {
    (event: "update:isMuted", isMuted: boolean): void;
  }
  interface Props {
    isMuted: boolean;
    width: number;
    disabled?: boolean;
  }
  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();

  const computedData = computed<boolean>({
    get: () => props.isMuted,
    set: value => {
      emit("update:isMuted", value);
    },
  });
</script>

<template>
  <AtomsIconSwitch
    v-model:is-on="computedData"
    img-on="assets/images/icon/video-mute.svg"
    img-off="assets/images/icon/video.svg"
    :width="width"
    :disabled="disabled"
  />
</template>
